function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { Children } from 'react';

/**
 * Finds the first child in a collection of React children that matches the type
 *
 * @param {React.ReactNode} children
 * @param {string | React.ComponentClass} type
 * @returns {React.ReactNode | undefined}
 */
export var findChildByType = function findChildByType(children, type) {
  return Children.toArray(children).find(function (child) {
    return child.type === type;
  });
};
export var findChildrenByType = function findChildrenByType(children) {
  for (var _len = arguments.length, types = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    types[_key - 1] = arguments[_key];
  }
  return Children.toArray(children).filter(function (child) {
    return child.type && types.includes(child.type);
  });
};

/**
 * Modifies a collection of React children by omitting children of specific type(s)
 *
 * @param {React.ReactNode} children
 * @param {...string | ...React.ComponentClass} type
 * @returns {[React.ReactNode]}
 */
export var filterOutChildrenByType = function filterOutChildrenByType(children) {
  for (var _len2 = arguments.length, types = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    types[_key2 - 1] = arguments[_key2];
  }
  return Children.toArray(children).filter(function (child) {
    return !child.type || !types.includes(child.type);
  });
};

/**
 * Extracts contents from a child of a specific type from a collection of
 * React children
 *
 * @param {React.ReactNode} children
 * @param {string | React.ComponentClass} type
 * @returns {React.ReactNode | undefined}
 */
export var getChildContents = function getChildContents(children, type) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var child = findChildByType(children, type);
  return child !== undefined ? child.props.children : defaultValue;
};
export var mapChildToParentPropsFactory = function mapChildToParentPropsFactory(type, map) {
  return function (children) {
    var child = findChildByType(children, type);
    if (!child) return {};
    var childPropKeys = Object.keys(child.props);
    return Object.keys(map).reduce(function (parentProps, childPropKey) {
      if (childPropKeys.includes(childPropKey)) {
        // eslint-disable-next-line no-param-reassign
        parentProps[map[childPropKey]] = child.props[childPropKey];
      }
      return parentProps;
    }, {});
  };
};
export var elementOfPropType = function elementOfPropType() {
  for (var _len3 = arguments.length, types = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    types[_key3] = arguments[_key3];
  }
  return function (props, propName, componentName) {
    if (props[propName] && (!props[propName].type || !types.includes(props[propName].type))) {
      return new Error("Invalid prop '".concat(propName, "' supplied to '").concat(componentName, "'. Expected element of type '").concat(types.map(function (t) {
        return t.displayName || t.name;
      }).join(', '), "' but received '").concat(props[propName].type ? props[propName].type.displayName : _typeof(props[propName]), "'"));
    }
    return undefined;
  };
};